import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { LoadingBar } from '../../components/util/LoadingBar';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { SliderControl } from '../../components/controls/NewSliderControl';
import { Checkbox } from 'rmwc/Checkbox';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';
import { currencyFormatter } from '../../components/Money';

class RiskComfort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      riskComfort: props.qna_hash.riskComfort ? props.qna_hash.riskComfort.answer : 2,
      riskComfortUnknown: props.qna_hash.riskComfortUnknown ? props.qna_hash.riskComfortUnknown.answer : false,
    };
  }

  componentDidMount() {
    this.props.pathAware('riskComfort');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.riskComfort) {
      this.setState({
        riskComfort: props.qna_hash.riskComfort.answer,
        riskComfortUnknown: props.qna_hash.riskComfortUnknown.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        riskComfort: {
          question: 'What level of risk are you comfortable with?',
          answer: this.state.riskComfort,
        },
        riskComfortUnknown: {
          question: 'Do you not know or are you not sure about your risk level?',
          answer: this.state.riskComfortUnknown,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = evt => {
    this.setState({ riskComfort: evt.detail.value });
  };

  onChangeRiskUnknown = evt => {
    this.setState({ riskComfortUnknown: evt.target.checked });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const { riskComfort, riskComfortUnknown } = this.state;

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">What level of risk<sup className="text-muted">1</sup> are you comfortable with?</Text>
        </div>
        {riskComfortUnknown || (
          <div className="mt-3" style={{ width: '90%', display: 'flex', justifyContent: 'space-around' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '115px' }}>
              <Text className="m-0" use="body1">
                Low Risk
              </Text>
              <Text className="m-0" use="body1">
                Low Return
              </Text>
            </div>
            <SliderControl
              id="riskComfort"
              className="ml-3 mr-3"
              style={{ width: '70%' }}
              spec={{
                field_type: 'range',
                min: 1,
                max: 5,
                step_size: 1,
                _default: 2,
              }}
              onChange={this.onChange}
              onInput={this.onChange}
              value={riskComfort}
              discrete
              persistentPin
            />
            <div style={{ display: 'flex', flexDirection: 'column', width: '115px' }}>
              <Text className="m-0" use="body1">
                High Risk
              </Text>
              <Text className="m-0" use="body1">
                High Return
              </Text>
            </div>
          </div>
        )}
        <Checkbox
          id="riskComfortUnknown"
          onChange={this.onChangeRiskUnknown}
          checked={riskComfortUnknown}
          label="I don't know or I'm not sure"
        />
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(RiskComfort);
